const ArrowButton = ({ onClick, direction, visibleCondition }) => {
  // [모바일 폭 반환] padding 20px 화살표 2개가 폰에서 ~120px를 차지해
  // 문제 기둥이 좁아지던 제1원인. 폰만 축소(터치 최소 32px 유지), PC 원본.
  const m = Math.min(window.innerWidth, window.screen.width) <= 768;
  return (
    <button
      onClick={onClick}
      style={{
        border: "none",
        background: "none",
        visibility: visibleCondition ? "visible" : "hidden",
        marginRight: direction == "left" && (m ? "2px" : "12px"),
        padding: m ? "6px" : "20px", // [모바일 폭 반환] 터치영역 폰 축소
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: m ? "12px" : "15px",
          height: m ? "12px" : "15px",
          borderTop: "2px solid #BEBEBE", // 상단 선
          borderRight: "2px solid #BEBEBE", // 우측 선
          transform: direction === "left" ? "rotate(-135deg)" : "rotate(45deg)", // 45도 회전
        }}
      ></div>
    </button>
  );
};

export default ArrowButton;
